import {getNotificationUnreadCount} from '../services/notifications.http'
import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'

export const useGetNotificationUnreadCount = () => {
    const query = useQuery({
        queryKey: [QUERY_KEYS.notificationUnreadCount],
        queryFn: getNotificationUnreadCount
    })
    return {...query, data: query.data ?? {count: 0}}
}
